import { useCallback, useEffect, useState } from "react";

import client from "../../client";
import handleApiError from "../../../hooks/handleApiError";

export default function useFetchAcademicSessionById(academicSessionId) {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState(null);

  const request = useCallback(async (id) => {
    try {
      setLoading(true);

      const res = await client.get(`/calendar/academic-sessions/${id}`);

      setData(res.data?.data);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      handleApiError(error);
    }
  }, []);

  useEffect(() => {
    if (academicSessionId) request(academicSessionId);
  }, [academicSessionId, request]);

  return { data, loading, request };
}
